import React from "react";
import { Box, Button, Typography } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { PREMIUM_PRICE_PER_MONTH, TRIAL_CTA, TRIAL_TERMS } from "../config/pricing";
import { storeAvailabilitySentence } from "../utils/storeAvailabilitySummary";

/**
 * The product page's "State Availability" panel for everyone without Premium
 * (#392). It used to draw a blurred map and store list from eight hard-coded
 * states and print "Available in 6 of 50 states" on every product, sold out or
 * not. Everything here is either a number the API gives everyone or a
 * description of what Premium shows.
 */
const LockedStateAvailability = ({ overview, bestBuyInStore, bestBuyOnline, microCenterInStore, microCenterStale }) => {
    const { isAuthenticated, login, user } = useAuth();
    const sentence = storeAvailabilitySentence({
        overview,
        bestBuyInStore,
        bestBuyOnline,
        microCenterInStore,
        microCenterStale,
    });
    // One trial per account; someone who has had theirs is quoted the price instead.
    const canUseTrial = !user?.hasUsedFreeTrial;

    return (
        <Box sx={{ p: 2 }} data-testid="locked-state-availability">
            {sentence && (
                <Typography variant="body1" fontWeight="bold" sx={{ mb: 1 }}>
                    {sentence}
                </Typography>
            )}
            <Typography variant="body2" color="text.secondary">
                <LockIcon sx={{ fontSize: 14, verticalAlign: "-2px", mr: 0.5 }} />
                Premium shows which states have it, the retailer, and the ZIP code to use for pickup.
            </Typography>
            {isAuthenticated ? (
                <Button
                    variant="contained"
                    color="primary"
                    component={Link}
                    to="/subscription"
                    sx={{ mt: 2 }}
                >
                    {canUseTrial ? TRIAL_CTA : `Upgrade to Premium - ${PREMIUM_PRICE_PER_MONTH}`}
                </Button>
            ) : (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => login()}
                    sx={{ mt: 2 }}
                >
                    Sign in to Upgrade
                </Button>
            )}
            {canUseTrial && (
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
                    {TRIAL_TERMS}
                </Typography>
            )}
        </Box>
    );
};

export default LockedStateAvailability;
